<div class="accordion_product_details">
	<div class="acc_head" (click)="accTriger(0)">
		Product Overview
	</div>
	<div class="acc_body {{deltaIndex == 0?'active':''}}">
		<p [innerHTML]="dataAccordion.productOverview | safeHtml">
		</p>
		<div class="heading_and_points_cont">
			<span class="heading">{{dataAccordion.productGroup === 'finished'? 'Product': 'Craft'}}</span>
			<a (click)="navigate(isFabric,dataAccordion.segment.name, dataAccordion.subCategory.name)">
				<span class="points capitalize">{{dataAccordion.subCategory.name.toLowerCase()}}</span>
			</a>

		</div>

		<div class="heading_and_points_cont">
			<span class="heading">Material</span>
			<ng-container *ngFor="let material of dataAccordion.materials; let i = index">
				<a (click)="navigate(isFabric,'material', material.name)">
				<span class="points">{{material.name}}
					<i *ngIf="dataAccordion.materials.length>1
					&&((i+1)!=dataAccordion.materials.length)">,</i>&nbsp;
				</span>
				</a>
			</ng-container>

		</div>
		<div class="heading_and_points_cont" *ngIf="dataAccordion.patterns">
			<span class="heading">Pattern</span>
			<ng-container *ngFor="let pattern of dataAccordion.patterns; let n = index">
				<a (click)="navigate(isFabric,'pattern', pattern.name)">
				<span class="points">{{pattern.name}}
					<i *ngIf="dataAccordion.patterns.length>1
					&&((n+1)!=dataAccordion.patterns.length)">,</i>&nbsp;
				</span>
				</a>
			</ng-container>
		</div>
		<div class="heading_and_points_cont color_outer" *ngIf="dataAccordion.colors">
			<span class="heading">Color</span>
			<span class="points points_for_color">
				<ng-container *ngFor="let color of dataAccordion.colors; let p = index">
					<span class="color_wrapper">
						<a (click)="navigate(isFabric,'color', color.name)">
							<b>{{color.name}}</b>
							<span [style.background]="color.hex"></span>
						</a>
					</span>
					<i *ngIf="dataAccordion.colors.length>1
						&&((p+1)!=dataAccordion.colors.length)">, </i>&nbsp;
				</ng-container>
				<!-- <span class="color_wrapper">white
					<span style="background-color: white;"></span>
				</span>,
				<span class="color_wrapper">Aqua
					<span style="background-color: aqua;"></span>
				</span> -->
			</span>
		</div>
		<div class="heading_and_points_cont" *ngIf="dataGsm.gsm  && dataGsm.width">
			<span class="heading">GSM</span>
			<span class="">
				<div class="gms_and_weight_cont">
					<div class="weight" *ngIf="dataGsm.gsm">Weight: {{dataGsm.gsm}}</div>
					<span *ngIf="dataGsm.gsm">&nbsp;|&nbsp;</span>
					<div class="width">
						Width: {{dataGsm.width}}
					</div>
				</div>
			</span>
		</div>
		<div class="heading_and_points_cont">
			<span class="heading">Origin</span>
			<span class="points no_border">India</span>
		</div>
	</div>

	<div class="acc_head" (click)="accTriger(1)">
		Product Care
	</div>
	<div class="acc_body  {{deltaIndex == 1?'active':''}}">
		<p [innerHTML]="dataAccordion.productCare | safeHtml">

		</p>
	</div>

	<div class="acc_head " (click)="accTriger(2)">
		Contact Us
	</div>
	<div class="acc_body  {{deltaIndex == 2?'active':''}}">
		<div class="footer_contact_info">
			<div class="contact_us_info">
				<span class="material-symbols-outlined for_info_icon">
					mail
				</span>
				<p><a href="mailto:support@anuprerna.com">support&#64;anuprerna.com</a></p>
			</div>
			<div class="contact_us_info">
				<span class="for_info_image">
					<img src="../../../assets/img/whatsapp.svg"/>
				</span>
				<p><a href="tel:+91 74831 94942">+91 74831 94942</a></p>
			</div>
			<div class="contact_us_info">

				<p>Have further queries? <a class="underline" href="/contact">Contact us Here</a></p>
			</div>
			<div class="follow_us_cont">
				<p>Follow Us:</p>
				<a href="https://twitter.com/Anuprerna6"><img src="https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/twitter.svg"/></a>
				<a href="https://www.facebook.com/anuprernatelier/"><img src="https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/facebook.svg"/></a>
				<a href="https://in.pinterest.com/anuprernas/"><img src="https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/pininterest.svg"/></a>
				<a href="https://www.instagram.com/anuprerna_atelier/"><img src="https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/instagram.svg"/></a>
			</div>
		</div>
	</div>
</div>
